/**
 * PR #767 — Canonical logical product profile catalog.
 *
 * The client is only allowed to reference the logical identifiers declared here.
 * Mapping a logical profile onto a concrete provider/model profile is a
 * server-side responsibility (see packages/server/src/provider/logicalProfileResolution.ts).
 * No provider or model name appears in this catalog, so no UI that consumes it can
 * become a raw model-selection authority.
 */
export const SMART_SHIKKA_LOGICAL_PROFILES = [
    {
        id: "auto",
        label: { en: "Auto", hi: "ऑटो" },
        description: {
            en: "Server chooses the profile for the active mode.",
            hi: "सर्वर सक्रिय मोड के लिए प्रोफ़ाइल चुनता है।",
        },
    },
    {
        id: "fast",
        label: { en: "Fast", hi: "फ़ास्ट" },
        description: {
            en: "Lower latency, shorter answers.",
            hi: "कम विलंब, छोटे उत्तर।",
        },
    },
    {
        id: "reasoning",
        label: { en: "Reasoning", hi: "रीज़निंग" },
        description: {
            en: "Deeper reasoning for harder work.",
            hi: "कठिन काम के लिए गहरा विश्लेषण।",
        },
    },
    {
        id: "coding",
        label: { en: "Coding", hi: "कोडिंग" },
        description: {
            en: "Code-aware reasoning for inspect/plan/patch work.",
            hi: "कोड inspect/plan/patch के लिए code-aware विश्लेषण।",
        },
    },
    {
        id: "creative",
        label: { en: "Creative", hi: "क्रिएटिव" },
        description: {
            en: "Long-form and ideation-oriented writing.",
            hi: "लंबे लेखन और ideation के लिए।",
        },
    },
    {
        id: "private-local",
        label: { en: "Private / Local", hi: "प्राइवेट / लोकल" },
        description: {
            en: "Only verified local-model profiles — no cloud provider.",
            hi: "केवल verified local-model प्रोफ़ाइल — कोई cloud प्रदाता नहीं।",
        },
    },
];
export const SMART_SHIKKA_PRODUCT_MODES = [
    // Only controls with a real canonical effect on the mode's runtime are declared.
    // `/api/ask` forwards a bounded `temperature`, so Chat exposes creativity; the
    // Design Studio renderer is deterministic, so Design/Cover expose neither a
    // profile nor creativity, and no mode exposes a project-trust control because no
    // canonical project-scoped trust semantics are reachable from these surfaces.
    { id: "chat", label: { en: "Chat", hi: "चैट" }, selectorControls: ["profile", "creativity"] },
    { id: "code", label: { en: "Code", hi: "कोड" }, selectorControls: ["profile", "effort"] },
    { id: "design", label: { en: "Shikka Design", hi: "शिक्का डिज़ाइन" }, selectorControls: [] },
    { id: "cover", label: { en: "Cover", hi: "कवर" }, selectorControls: ["preset"] },
];
export const SMART_SHIKKA_EFFORT_LEVELS = [
    { id: "low", label: { en: "Effort: Low", hi: "प्रयास: कम" } },
    { id: "medium", label: { en: "Effort: Medium", hi: "प्रयास: मध्यम" } },
    { id: "high", label: { en: "Effort: High", hi: "प्रयास: अधिक" } },
];
export function isSmartShikkaLogicalProfileId(value) {
    return SMART_SHIKKA_LOGICAL_PROFILES.some((profile) => profile.id === value);
}
export function isSmartShikkaProductMode(value) {
    return SMART_SHIKKA_PRODUCT_MODES.some((mode) => mode.id === value);
}
export function isSmartShikkaEffortLevel(value) {
    return SMART_SHIKKA_EFFORT_LEVELS.some((level) => level.id === value);
}
export function getSmartShikkaProductMode(value) {
    return SMART_SHIKKA_PRODUCT_MODES.find((mode) => mode.id === value);
}
//# sourceMappingURL=productProfileCatalog.js.map